module.exports = __webpack_public_path__ + "static/img/cloud.6de6b200.png";